import { render, staticRenderFns } from "./ExportManuscriptDialog.vue?vue&type=template&id=66f10a66&scoped=true"
import script from "./ExportManuscriptDialog.vue?vue&type=script&lang=ts"
export * from "./ExportManuscriptDialog.vue?vue&type=script&lang=ts"
import style0 from "./ExportManuscriptDialog.vue?vue&type=style&index=0&id=66f10a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f10a66",
  null
  
)

export default component.exports